/**
 * Class defining tournament data descriptors.
 *
 * @class TournamentsDataDescriptors
 * @name descriptors
 * @memberof Mojito.Services.SportsContent.Tournaments
 */
export default class TournamentsDataDescriptors {
    /**
     * Factory method for creating a tournament data descriptor.
     *
     * @param {string} tournamentId - The tournament id.
     * @returns {{dataType: string, tournamentId: *}} Tournament data descriptor.
     * @function Mojito.Services.SportsContent.Tournaments.descriptors#createTournamentDescriptor
     * @static
     */
    static createTournamentDescriptor(tournamentId) {
        return {
            dataType: TournamentsDataDescriptors.DATA_TYPES.TOURNAMENT,
            tournamentId,
        };
    }
}

/**
 * System unique data descriptor types.
 *
 * @typedef DATA_TYPES
 * @property {string} TOURNAMENT - Tournament data descriptor type.
 *
 * @memberof Mojito.Services.SportsContent.Tournaments.descriptors
 */
TournamentsDataDescriptors.DATA_TYPES = {
    TOURNAMENT: 'tournament',
};
